/**
 * Smooth scroll with offset for sticky header
 * Handles all internal anchor links with 90px offset
 */

document.addEventListener("DOMContentLoaded", function () {
  // Offset for sticky header
  const SCROLL_OFFSET = 140;

  // Function to smooth scroll to target with offset
  function smoothScrollToTarget(target, offset = 0) {
    const targetElement = document.querySelector(target);
    if (!targetElement) return false;

    const targetPosition =
      targetElement.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: targetPosition,
      behavior: "smooth",
    });

    return true;
  }

  // Handle all anchor links that start with #
  document.addEventListener("click", function (e) {
    const link = e.target.closest('a[href^="#"]');

    if (!link) return;

    const href = link.getAttribute("href");

    // Skip empty anchors or just #
    if (!href || href === "#") return;

    // Check if target element exists
    const targetElement = document.querySelector(href);
    if (!targetElement) return;

    // Prevent default behavior
    e.preventDefault();

    // Smooth scroll to target with offset
    smoothScrollToTarget(href, SCROLL_OFFSET);

    // Update URL hash without jumping
    if (history.pushState) {
      history.pushState(null, null, href);
    }
  });

  // Handle direct hash navigation (when page loads with hash)
  function handleHashOnLoad() {
    const hash = window.location.hash;
    if (hash && hash.length > 1) {
      // Small delay to ensure page is fully loaded
      setTimeout(() => {
        smoothScrollToTarget(hash, SCROLL_OFFSET);
      }, 100);
    }
  }

  // Handle hash on page load
  handleHashOnLoad();

  // Handle browser back/forward navigation
  window.addEventListener("popstate", function () {
    handleHashOnLoad();
  });
});
